export function parsePartNumber(productPartNumber) {
  // If a single number
  if (!productPartNumber.match(/[+-]/)) {
    return [productPartNumber];
  }

  const validCodes = [];
  const groupsToProcess = productPartNumber.split("+");

  groupsToProcess.forEach((group) => {
    insertValidCodes(validCodes, group);
  });

  return validCodes;
}

// Parses and inserts the valid codes into a given array
function insertValidCodes(validCodesArray, groupToProcess) {
  if (!groupToProcess.includes("-")) {
    validCodesArray.push(groupToProcess);
    return;
  }

  // If it is a range, get low high tuple/array e.g: 1-7 -> [1, 7]
  const [start, end] = groupToProcess.split("-");

  // If given an invalid duplicate range, just push it on
  // it will be validated later
  if (start === end) {
    validCodesArray.push(start, end);
    return;
  }

  // Convert to integers
  const startNum = parseInt(start, 10);
  const endNum = parseInt(end, 10);

  // Determine direction of the range
  const step = startNum <= endNum ? 1 : -1;

  // Push values within range to valid codes array
  // Using Math.sign to determine inclusive end condition
  for (let i = startNum; step > 0 ? i <= endNum : i >= endNum; i += step) {
    validCodesArray.push(i.toString());
  }
}

export function isValidChildPartNumber(parentNumber, childNumber) {
  if (!parentNumber || !childNumber) return false;

  const allowedValues = parsePartNumber(parentNumber);
  const childValues = parsePartNumber(childNumber);

  // Return true only if ALL child values are included in allowed values
  return childValues.every((val) => allowedValues.includes(val));
}
